<template>
    <div class="cart__item">
        <span>{{ name }} </span><a @click="removeFromCart()" style="float: right;"><i class="far fa-trash-alt" aria-hidden="true"></i></a>
    </div>
</template>

<script>
    import ajax from '../../ajax';

    export default {
        props: ['item'],

        data() {
            return {
                id: null,
                name: null
            }
        },
        methods: {
            removeFromCart() {
                let products    = JSON.parse(localStorage.getItem("products"));
                let index       = products.findIndex(product => product.id === this.$data.id);
                products.splice(index, 1);
                localStorage.setItem('products', JSON.stringify(products));
                this.$root.$emit('fetch-cart-items');
            }
        },
        mounted () {
            ajax
            .get(`/api/v1/product/${this.item.id}`)
            .then(response =>{
                if(response.status === 200) {
                    this.id     = response.data.id,
                    this.name   = response.data.name
                }
            })
            .catch(error =>{
                console.log(error);
            })
        }
    }
</script>

<style scoped lang="scss">
    
    .cart__item_wrapper i {
        color: white;
    }

    .cart__item a:hover {
        cursor: pointer;
    }   

    span {
        color: white;
    }

</style>